const buildAcceptingApplicationsCheckDataObject = (uData) => {
  const dataObject = {
    qdbapi: {
      udata: uData,
      fmt: "structured",
    },
  };
    dataObject.qdbapi.query = `{'3'.EX.'13'}`;
  return dataObject;
};

export default buildAcceptingApplicationsCheckDataObject;